import React, { useState, useEffect } from 'react';
import AppBar from '@material-ui/core/AppBar';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardMedia from '@material-ui/core/CardMedia';
import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';
import StarIcon from '@material-ui/icons/StarBorder';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Box from '@material-ui/core/Box';
import Icon from '@material-ui/core/Icon';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
import Divider from '@material-ui/core/Divider';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';
import CreditCardOffIcon from '@mui/icons-material/CreditCardOff';
import CodeOffIcon from '@mui/icons-material/CodeOff';
import CodeIcon from '@mui/icons-material/Code';
import Alert from '@mui/material/Alert';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';

import Base13Icon from './../../Color just logo - no background.svg';
import Base13Logo from './../../Color logo - no background.png';
import FacebookLogo from './../../facebookLogo.png';
import GoogleAdsLogo from './../../googleAdsLogo.png';
import GoogleAnalyticsLogo from './../../googleAnalyticsLogo.png';
import ShopifyLogo from './../../shopifyLogo.png';
import KlaviyoLogo from './../../klaviyoLogo.png';
import AirflowLogo from './../../airflowLogo.png';
import DBTLogo from './../../dbtLogo.svg';
import DagsterLogo from './../../dagsterLogo.svg';
import PrefectLogo from './../../prefectLogo.png';
import PythonLogo from './../../pythonLogo.png';
import CRONLogo from './../../cronLogo.png';
import FlowChart from './../../flowChart.png';
import FloSystemGraphic from './../../floSystemGraphic.svg';
import FloSQLIntegrationsGraphic from './../../floSQLIntegrationsGraphic.svg';
import MonitoringPipelines from './../../monitoringPipelines.png';
import CircularFlowIngestExport from './../../CircularFlowIngestExport1.png';
import MonitoringTasks from './../../monitoringTasks.png';
import ModelEditor from './../../modelEditor.png';
import SnowflakeLogo from './../../Snowflake_logo.png';
import RedshiftLogo from './../../redshiftLogo.png';
import BigQueryLogo from './../../bigqueryLogo.png';
import PostgreSQLLogo from './../../postgresqlLogo.png';
import MySQLLogo from './../../mysqlLogo.png';
import RedashLogo from './../../redash_logo.png';
import SlackLogo from './../../slackLogo.png';
import StreamLocatorLogo from './../../StreamLocator_logo.png';
import SMSLiveLogo from './../../smsliveLogo.png';
import OverlayFlowEditor from './../../overlayFlowEditor.svg';
import StatusFlowOverlay from './../../statusFlowOverlay.svg';
import MonitoringSnap from './../../monitoringSnapSlack.svg';

import ModelEditorGIF from './../../sql_editor_clip.gif';
import MonitoringValidationsGIF from './../../monitoring_validations.gif';
import TemplatesGIF from './../../templates.gif';
import TeamCollaborationGIF from './../../team_collaboration.gif';
import ArrowForwardOutlinedIcon from '@mui/icons-material/ArrowForwardOutlined';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import DangerousIcon from '@mui/icons-material/Dangerous';
import CheckIcon from '@mui/icons-material/Check';
import ClearIcon from '@mui/icons-material/Clear';

import StreamLocatorLogoGrey from './../../StreamLocator_logoGrey.png';
import SMSLiveLogoGrey from './../../smsliveLogoGrey.png';
import PBPLogoGrey from './../../pbp_logo_200Grey.png';
import EmergeLogoGrey from './../../emergeLogoGrey.png';

import { PopupButton, PopupWidget } from "react-calendly";

import Header from './Header';
import Footer from './Footer';
import RequestDemo from './RequestDemo';
import FreeTrial from './FreeTrial';

const useStyles = makeStyles((theme) => ({
  '@global': {
    ul: {
      margin: 0,
      padding: 0,
      listStyle: 'none',
      autoWidth: 'false',
    },
  },
  logo: {
    width: 165,
    height: 48,
  },
  snowflakeLogo: {
    width: '75vw',
    maxWidth: 512,
    // height: 256,
  },
  snowflakeLogoSmall: {
    width: '75vw',
    maxWidth: 200,
    // height: 256,
  },
  redshiftLogo: {
    width: '75vw',
    maxWidth: 150,
    // height: 256,
  },
  bigqueryLogo: {
    width: '75vw',
    maxWidth: 150,
    // height: 256,
  },
  postgresqlLogo: {
    width: '75vw',
    maxWidth: 150,
    // height: 256,
  },
  mysqlLogo: {
    width: '75vw',
    maxWidth: 110,
    // height: 256,
  },
  slackLogo: {
    width: '75vw',
    maxWidth: 110,
    // height: 256,
  },
  redashLogo: {
    width: '75vw',
    maxWidth: 512,
    // height: 312,
  },
  streamLocatorLogo: {
    width: '75vw',
    maxWidth: 200,
    paddingTop: 20,
    // marginRight: 100,
    // height: 312,
  },
  smsLiveLogo: {
    width: '75vw',
    maxWidth: 175,
    paddingTop: 10,
    // marginRight: 100,
    // height: 312,
  },
  shopifyLogo: {
    flex: 1,
    padding: 2,
    maxWidth: 50,
    resizeMode: 'contain'
  },
  facebookLogo: {
    flex: 1,
    padding: 2,
    maxWidth: 65,
    resizeMode: 'contain'
  },
  googleAnalyticsLogo: {
    flex: 1,
    padding: 2,
    spacing: 10,
    maxWidth: 100,
    resizeMode: 'contain'
  },
  googleAdsLogo: {
    flex: 1,
    padding: 2,
    spacing: 10,
    maxWidth: 48,
    resizeMode: 'contain'
  },
  klaviyoLogo: {
    flex: 1,
    padding: 2,
    spacing: 10,
    maxWidth: 70,
    resizeMode: 'contain'
  },
  airflowLogo: {
    flex: 1,
    padding: 2,
    spacing: 10,
    maxWidth: 40,
    resizeMode: 'contain'
  },
  dbtLogo: {
    flex: 1,
    padding: 2,
    spacing: 10,
    maxWidth: 40,
    resizeMode: 'contain'
  },
  dagsterLogo: {
    flex: 1,
    padding: 2,
    spacing: 10,
    maxWidth: 40,
    resizeMode: 'contain'
  },
  prefectLogo: {
    flex: 1,
    padding: 2,
    spacing: 10,
    maxWidth: 50,
    resizeMode: 'contain'
  },
  cronLogo: {
    flex: 1,
    padding: 1,
    spacing: 10,
    maxWidth: 60,
    resizeMode: 'contain'
  },
  pythonLogo: {
    flex: 1,
    padding: 0,
    spacing: 10,
    maxWidth: 40,
    resizeMode: 'contain'
  },
  logoPadding: {
    flex: 1,
    padding: 2,
    maxWidth: 20,
    resizeMode: 'contain'
  },
  dwdblogoPadding: {
    flex: 1,
    padding: 2,
    maxWidth: 10,
    resizeMode: 'contain'
  },
  button: {
    margin: theme.spacing(1),
  },
  image: {
    flex: 1,
    padding: 2,
    maxWidth: 120,
    // height: 100,
    resizeMode: 'contain'
  },
  flowChart: {
    flex: 1,
    padding: 2,
    width: '75vw',
    maxWidth: 932,
    // height: 400,
    resizeMode: 'contain'
  },
  overlayFlowEditor: {
    flex: 1,
    padding: 2,
    width: '75vw',
    maxWidth: 1032,
    // height: 400,
    resizeMode: 'contain'
  },
  statusFlowOverlay: {
    flex: 1,
    padding: 2,
    width: '75vw',
    maxWidth: 1032,
    // height: 400,
    resizeMode: 'contain'
  },
  monitoringSnap: {
    flex: 1,
    padding: 2,
    width: '75vw',
    maxWidth: 1032,
    resizeMode: 'contain'
  },
  floSystemGraphic: {
    flex: 1,
    padding: 2,
    width: '75vw',
    maxWidth: 972,
    resizeMode: 'contain'
  },
  floSQLIntegrationsGraphic: {
    flex: 1,
    padding: 2,
    width: '75vw',
    maxWidth: 972,
    // height: 400,
    resizeMode: 'contain'
  },
  modelEditor: {
    flex: 1,
    padding: 2,
    width: '75vw',
    maxWidth: 972,
    // height: 547,
    resizeMode: 'contain'
  },
  monitoringValidations: {
    flex: 1,
    padding: 2,
    width: '75vw',
    maxWidth: 800,
    // height: 547,
    resizeMode: 'contain'
  },
  templates: {
    flex: 1,
    padding: 2,
    width: '75vw',
    maxWidth: 800,
    //1080,
    // height: 608,
    resizeMode: 'contain'
  },
  teamCollaboration: {
    flex: 1,
    padding: 2,
    width: '75vw',
    maxWidth: 972,
    // height: 608,
    resizeMode: 'contain'
  },
  paper: {
    maxWidth: 100,
    // height: 102,
    borderRadius:16,
    margin: 'auto',
    justifyContent: 'center',
  },
  link: {
    margin: theme.spacing(1, 1.5),
    textDecoration: 'none',
    color: 'white',
    underline: 'none',
    hover: {
    "&:hover": {
      color: '#cbd5e1'
      }
    }
  },
  heroContent: {
    padding: theme.spacing(8, 0, 6),
    //backgroundColor: "#cccccc",
  },
  cardCaseStudy: {
    // maxWidth: 972,
    transition: "0.3s",
    boxShadow: "0 8px 40px -12px rgba(0,0,0,0.3)",
    "&:hover": {
      boxShadow: "0 16px 70px -12.125px rgba(0,0,0,0.3)"
    }
  },
  cardHeader: {
    backgroundColor:
      theme.palette.type === 'light' ? theme.palette.grey[200] : theme.palette.grey[700],
  },
  cardPricing: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'baseline',
    marginBottom: theme.spacing(2),
  },
}));

const tiers = [
  {
    title: 'Free',
    subheader: 'No credit card required',
    price: '$0',
    value: '1 seat',
    description: [
    'Up to 20 tasks',
    'Free Shopify Ingestion',
    'Data warehouse integration',
    'Github SSO',
    'Help center access',
    'Email support'
    ],
    buttonText: 'Get started for free',
    buttonVariant: 'outlined',
    buttonLink: '/SignUp/',
    buttonStyle: {
      color: 'white',
      backgroundColor:'#19affd',
      borderColor:'#19affd',
      textTransform: 'none'
    },
    style: {
      color: 'white',
      backgroundColor:'#19affd',
      borderColor:'#19affd'
    }
  },
  {
    title: 'Business',
    subheader: 'The One-click Modern Data Stack',
    price: '$99',
    value: ' per seat per month',
    description: [
      'Unlimited Tasks',
      'Access to 100s of ingestions',
      'Data warehouse integration',
      'Github SSO',
      'Help center access',
      'Email support',
    ],
    buttonText: '14-day Free Trial',
    buttonVariant: 'contained',
    buttonLink: '/FreeTrial',
    buttonStyle: {
      color: 'white',
      backgroundColor:'#0284c7',
      borderColor:'#0284c7',
      textTransform: 'none'
    },
    style: {
      color: 'white',
      backgroundColor:'#0284c7',
      borderColor:'#0284c7',
      textTransform: 'none'
    }
  },
  {
    title: 'Enterprise',
    subheader: 'Tailored to your needs',
    price: 'Contact Us',
    value: 'Unlimited seats',
    description: [
      'Unlimited Tasks',
      'Custom Ingestions and Exports',
      'Data warehouse integration',
      'Custom SSO',
      'Help center access',
      'Phone & email support',
    ],
    buttonText: 'Contact Us',
    buttonVariant: 'outlined',
    buttonLink: '/RequestDemo',
    buttonStyle: {
      color: 'white',
      backgroundColor:'#01527c',
      borderColor:'#01527c',
      textTransform: 'none'
    },
    style: {
      color: 'white',
      backgroundColor:'#01527c',
      borderColor:'#01527c'
    },
  },
];

export default function HomePage() {
  const classes = useStyles();
  const [open, setOpen] = React.useState(true);

  return (
    <React.Fragment>
      <CssBaseline />
      <Header/>


      <Container maxWidth="lg" component="main" className={classes.heroContent} style={{color:"#37474f"}} >
      <Box style={{padding:10}}></Box>
      <Grid container alignItems="flex-end" >
      <Grid xs={12} sm={3} md={3} lg={3} alignItems="flex-end"></Grid>
      <Grid xs={12} sm={6} md={6} lg={6} alignItems="flex-end">
      <Box sx={{ width: '100%'}} >
      <Collapse in={open}>
        <Alert color="info"
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
                setOpen(false);
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          }
          sx={{ mb: 2 }}
        >
          <Box sx={{ fontWeight: 'bold', alignItems:"center",
        justifyContent:"center"}} display='inline' >Take advantage of our FREE Shopify ETL ingestion for a limited time.</Box>
        </Alert>
      </Collapse>
    </Box>
    </Grid>
    <Grid xs={12} sm={3} md={3} lg={3} alignItems="flex-end"></Grid>
    </Grid>
      <Grid container alignItems="flex-end" >
      <Grid xs={12} sm={12} md={12} lg={12} alignItems="flex-end">

        <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        style={{paddingTop:20, paddingBottom:20}}
        >
          <img className={classes.image} src={Base13Icon}/>
        </Box>
        <Box style={{padding:10}} >
        <Typography component="h1" variant="h3" style={{ fontStyle: 'bolded', fontFamily: 'Arial' }} align="center" color="textPrimary" gutterBottom>
          {/*<Box sx={{ fontWeight: 'bold'}} display='inline' >Build and deploy dbt models fast</Box>*/}
          <Box sx={{ fontWeight: 'bold'}} display='inline' >The One-click Modern Data Stack</Box>
          {/*<Box sx={{ fontWeight: 'bold'}} display='inline' >Build the future of analytics</Box>*/}
          {/*<Box sx={{ fontWeight: 'bold'}} display='inline' >Build the next generation of data tools</Box>*/}
          {/*<Box sx={{ fontWeight: 'bold'}} display='inline' >Let's build the future of analytics</Box>*/}
        </Typography>
        {/*<Typography variant="h5" style={{ fontFamily: 'Arial' }} align="center" color="textSecondary" component="p">
          Easily schedule and manage dependent data models for your SQL pipelines
        </Typography>*/}
        {/*<Typography variant="h5" style={{ fontFamily: 'Arial' }} align="center" color="textSecondary" component="p">
          From ETL to reverse-ETL build and schedule each transformation in FloSQL
        </Typography>*/}
        <Typography variant="h5" style={{ fontFamily: 'Arial' }} align="center" color="textSecondary" component="p">
          From ETL to reverse-ETL integrate and build each transformation in FloSQL
        </Typography>
        </Box>

        <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        style={{padding:20}}
        >
        <Stack
        direction={{ xs: 'column', sm: 'row' }}
        display="flex"
        alignItems="center"
        justifyContent="center"
        >
          <Box m="auto" className={classes.button}><Button size="medium" href='/SignUp/' variant="contained" style={{color: "white", backgroundColor:"#0284c7", borderColor:"#0284c7", fontSize: '20px', maxWidth: '250px', maxHeight: '50px', minWidth: '100px', minHeight: '20px', textTransform: 'none'}} >
          Get started for free</Button></Box>
          {/*Join our limited beta</Button></Box>*/}
          <Box className={classes.button}><Button size="medium" href='/RequestDemo' variant="outlined" style={{color:"#0284c7", borderColor:"#0284c7", fontSize: '20px', maxWidth: '250px', maxHeight: '50px', minWidth: '100px', minHeight: '20px', textTransform: 'none'}} >
          {/*Request demo</Button></Box>*/}
          Let's connect</Button></Box>
        </Stack>
        </Box>

        <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        style={{padding:0}}
        >
        <CreditCardOffIcon style={{color:'#0284c7', width:20, height:20}} fontsize="small"/>
        <Typography variant="p6" style={{ fontFamily: 'Arial', padding:10 }} align="center" color="textSecondary" component="p">
         <Box sx={{ fontWeight: 'bold'}} display='inline' >No credit card required</Box>
        </Typography>
        <CodeIcon style={{color:'#0284c7', width:20, height:20}} fontsize="small"/>
        <Typography variant="p6" style={{ fontFamily: 'Arial', padding:10 }} align="center" color="textSecondary" component="p">
         <Box sx={{ fontWeight: 'bold'}} display='inline' >Work with SQL</Box>
        </Typography>
        </Box>

        <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        style={{padding:0}}
        >
          <img className={classes.overlayFlowEditor} src={OverlayFlowEditor}/>
        </Box>

        <Box style={{padding:20}}></Box>

        <Grid container alignItems="flex-end" >
        <Grid xs={12} sm={12} md={12} lg={12} alignItems="flex-end">
        <Typography component="h5" variant="h5" style={{ fontStyle: 'bolded', fontFamily: 'Arial'}} align="center" justify="center" color="textSecondary" >
          Effective data teams use FloSQL
        </Typography>

        <Stack
        direction={{ xs: 'column', sm: 'row' }}
        spacing={{ xs: 1, sm: 2, md: 4 }}
        display="flex"
        alignItems="center"
        justifyContent="center"
        style={{padding:20}}
        >
          <img className={classes.streamLocatorLogo} style={{ maxWidth: 150 }} src={StreamLocatorLogoGrey}/>
          <img className={classes.dwdblogoPadding} />
          <img className={classes.smsLiveLogo} style={{ maxWidth: 175 }} src={PBPLogoGrey}/>
          <img className={classes.dwdblogoPadding} />
          <img className={classes.smsLiveLogo} style={{ maxWidth: 125 }} src={EmergeLogoGrey}/>
          <img className={classes.dwdblogoPadding} />
          <img className={classes.smsLiveLogo} style={{ maxWidth: 125 }} src={SMSLiveLogoGrey}/>

        </Stack>
        </Grid>
        </Grid>

        <Box style={{padding:50}}></Box>

        {/*<Typography component="h1" variant="h4" style={{ fontStyle: 'bolded', fontFamily: 'Arial' }} align="center" color="textPrimary" gutterBottom>
          <Box sx={{ fontWeight: 'bold'}} display='inline' >Build dependencies off of any model in any pipeline</Box>
        </Typography>*/}
        <Typography component="h1" variant="h4" style={{ fontStyle: 'bolded', fontFamily: 'Arial' }} align="center" color="textPrimary" gutterBottom>
          <Box sx={{ fontWeight: 'bold'}} display='inline' >Ingest, transform, and export 100+ connectors</Box>
        </Typography>
        <Typography variant="h5" style={{ fontFamily: 'Arial' }} align="center" color="textSecondary" component="p">
          Leverage dbt and Apache Airflow without the development time
        </Typography>
        {/*Manages all of your data model dependencies and optimize their run times
        Leverage dbt and Apache Airflow to manage your data model dependencies and optimize run times*/}
         <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        style={{padding:20}}
        >
          <img className={classes.floSQLIntegrationsGraphic} src={CircularFlowIngestExport}/>
        </Box>

        <Typography variant="h6" style={{ fontFamily: 'Arial' }} align="center" color="textSecondary" component="p">
         <Box sx={{ fontWeight: 'bold'}} display='inline' >Works with your favorite data warehouse or leverage our Snowflake instance</Box>
        </Typography>
        <Stack
        direction={{ xs: 'column', sm: 'row' }}
        spacing={{ xs: 1, sm: 2, md: 4 }}
        display="flex"
        alignItems="center"
        justifyContent="center"
        style={{padding:20}}
        >
          <img className={classes.postgresqlLogo} src={PostgreSQLLogo}/>
          <img className={classes.dwdblogoPadding} />
          <img className={classes.redshiftLogo} src={RedshiftLogo}/>
          <img className={classes.dwdblogoPadding} />
          <img className={classes.snowflakeLogoSmall} src={SnowflakeLogo}/>
          <img className={classes.dwdblogoPadding} />
          <img className={classes.bigqueryLogo} src={BigQueryLogo}/>
        </Stack>

        {/*<Box style={{padding:50}}></Box>*/}


        <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        style={{padding:20}}
        >
        <Stack
        direction={{ xs: 'column', sm: 'row' }}
        display="flex"
        alignItems="center"
        justifyContent="center"
        >
          <Box m="auto" className={classes.button}><Button size="medium" href='/SignUp/' variant="contained" style={{color: "white", backgroundColor:"#0284c7", borderColor:"#0284c7", fontSize: '20px', maxWidth: '250px', maxHeight: '50px', minWidth: '100px', minHeight: '20px', textTransform: 'none'}} >
          Get started for free</Button></Box>
          {/*Join our limited beta</Button></Box>*/}
          <Box className={classes.button}><Button size="medium" href='/RequestDemo' variant="outlined" style={{color:"#0284c7", borderColor:"#0284c7", fontSize: '20px', maxWidth: '250px', maxHeight: '50px', minWidth: '100px', minHeight: '20px', textTransform: 'none'}} >
          {/*Request demo</Button></Box>*/}
          Let's connect</Button></Box>
        </Stack>
        </Box>

        <Box style={{padding:30}}></Box>

        <Grid container spacing={5} alignItems="flex-end" direction="row" justifyContent="center" alignItems="center">
          <Grid item xs={12} sm={12} md={3} lg={3} >
            <Box style={{padding:20}} >
            <Typography component="h1" variant="h4" style={{ fontStyle: 'bolded', fontFamily: 'Arial', justifyContent: 'center' }} align="center" color="textPrimary" gutterBottom>
              <Box sx={{ fontWeight: 'bold', justifyContent: 'center'}} display='inline' >Create review data models</Box>
            </Typography>
            <Typography variant="h6" style={{ fontFamily: 'Arial' }} align="center" color="textSecondary" component="p">
              Compare a new version with an old one without affecting production models. Our comprehensive model status flow retains the entire history.
            </Typography>
            </Box>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="center"
              style={{padding:20}}
              >
              <Box m="auto" className={classes.button}><Button size="large" href='https://docs.flosql.com/tutorial-extras/models-page' variant="outlined" style={{color: "#0284c7", textTransform: 'none'}} target="_blank" >Review the docs</Button></Box>
            </Box>
          </Grid>
          <Grid item xs={12} sm={12} md={9} lg={9}>
            <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            style={{padding:10}}
            >
              <img className={classes.statusFlowOverlay} src={StatusFlowOverlay}/>
            </Box>
          </Grid>
        </Grid>

        <Box style={{padding:50}}></Box>

        <Grid container spacing={5} alignItems="flex-end" direction="row" justifyContent="center" justify="flex-start">
          <Grid item xs={12} sm={12} md={3} lg={3} order={{ xs: 1, sm: 1, md: 1, lg:1 }}>
            <Box style={{padding:10}} >
            <Typography component="h1" variant="h4" style={{ fontStyle: 'bolded', fontFamily: 'Arial', justifyContent: 'center'}} align="center" color="textPrimary" gutterBottom>
              <Box sx={{ fontWeight: 'bold', justifyContent: 'center'}} display='inline' >Reuse code to build faster</Box>
            </Typography>
            <Typography variant="h6" style={{ fontFamily: 'Arial' }} align="center" color="textSecondary" component="p">
              Leverage templates and variables to quickly build off of proven queries.
            </Typography>
            <Typography variant="h6" style={{ fontFamily: 'Arial' }} align="center" color="textSecondary" component="p">
              Automatic dependency mapping automatically parses through your SQL queries.
            </Typography>
            </Box>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="center"
              style={{padding:20}}
              >
              <Box m="auto" className={classes.button}><Button size="large" href='/RequestDemo' variant="outlined" style={{color: "#0284c7", textTransform: 'none'}} >Request demo</Button></Box>
            </Box>
          </Grid>
          <Grid item xs={12} sm={12} md={9} lg={9} order={{ xs: 2, sm: 2, md: 2, lg:2 }}>
            <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            style={{padding:10}}
            >
            <Paper elevation={2}>
              <img className={classes.templates} src={TemplatesGIF}/>
            </Paper>
            </Box>
          </Grid>
        </Grid>

        {/*<Box style={{padding:50}}></Box>

        <Typography component="h1" variant="h4" style={{ fontStyle: 'bolded', fontFamily: 'Arial' }} align="center" color="textPrimary" gutterBottom>
          <Box sx={{ fontWeight: 'bold'}} display='inline' >Reduce errors and save your time</Box>
        </Typography>
        <Typography variant="h5" style={{ fontFamily: 'Arial' }} align="center" color="textSecondary" component="p">
          Automatic Dependency Mapping in our editor automatically parses through your SQL queries
        </Typography>
        <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        style={{padding:40}}
        >
        <Paper elevation={5}>
          <img className={classes.modelEditor} src={ModelEditorGIF}/>
          </Paper>
        </Box>
        <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        style={{padding:10}}
        >
          <Box m="auto" className={classes.button}><Button size="large" href='/FreeTrial' variant="contained" style={{color: "white", backgroundColor:"#0284c7", borderColor:"#0284c7"}} >Try It Free</Button></Box>
        </Box>*/}

        <Box style={{padding:50}}></Box>

        <Grid container spacing={5} alignItems="flex-end" direction="row" justifyContent="center" alignItems="center">
          <Grid item xs={12} sm={12} md={3} lg={3} >
            <Box style={{padding:10}} >
            <Typography component="h1" variant="h4" style={{ fontStyle: 'bolded', fontFamily: 'Arial', justifyContent: 'center' }} align="center" color="textPrimary" gutterBottom>
              <Box sx={{ fontWeight: 'bold', justifyContent: 'center'}} display='inline' >Deploy dbt models to Apache Airflow</Box>
            </Typography>
            <Typography component="h1" variant="h4" style={{ fontStyle: 'bolded', fontFamily: 'Arial', justifyContent: 'center' }} align="center" color="textPrimary" gutterBottom>
              <Box sx={{ fontWeight: 'bold', justifyContent: 'center'}} display='inline' ></Box>
            </Typography>
            <Typography variant="h6" style={{ fontFamily: 'Arial' }} align="center" color="textSecondary" component="p">
              Monitoring and validations are integrated with Slack or Discord to ensure that you are the first to know about upstream data issues.
            </Typography>
            </Box>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="center"
              style={{padding:20}}
              >
              <Box m="auto" className={classes.button}><Button size="large" href='/SignUp/' variant="outlined" style={{color: "#0284c7", textTransform: 'none'}} >Try it free</Button></Box>
            </Box>
          </Grid>
          <Grid item xs={12} sm={12} md={9} lg={9}>
            <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            style={{padding:10}}
            >
              <img className={classes.monitoringSnap} src={MonitoringSnap}/>

            </Box>
          </Grid>
        </Grid>


        </Grid>
        </Grid>

        <Box style={{padding:50}}></Box>
        {/*<Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          style={{padding:20}}
          >

        <Grid container spacing={5} alignItems="flex-end">
            <Grid item xs={12} sm={12} md={6} lg={6}>
            <Paper elevation={2} variant="outlined">
            <Box style={{padding:20}}></Box>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                style={{padding:20}}
                >
                <Typography component="h1" variant="h4" style={{ fontStyle: 'bolded', fontFamily: 'Arial' }} align="center" color="textPrimary" gutterBottom>
                  Before FloSQL
                </Typography>
              </Box>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                style={{padding:20}}
                >
                <img className={classes.airflowLogo} src={AirflowLogo}/>
                  <img className={classes.logoPadding} />
                <img className={classes.dbtLogo} src={DBTLogo}/>
                  <img className={classes.logoPadding} />
                <img className={classes.dagsterLogo} src={DagsterLogo}/>
                  <img className={classes.logoPadding} />
              </Box>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                style={{padding:20}}
                >
                <img className={classes.prefectLogo} src={PrefectLogo}/>
                <img className={classes.cronLogo} src={CRONLogo}/>
                  <img className={classes.logoPadding} />
                <img className={classes.pythonLogo} src={PythonLogo}/>
                  <img className={classes.logoPadding} />
              </Box>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                style={{ padding:5}}
                >
                <ClearIcon  style={{color:"red", marginRight: 5, marginTop: 5}} />
                <Typography variant="h6" style={{ fontFamily: 'Arial' }} align="left" color="textPrimary" >
                  Complex open source tools
                </Typography>
              </Box>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                style={{ padding:5}}
                >
                <ClearIcon  style={{color:"red", marginRight: 5, marginTop: 5}}/>
                <Typography variant="h6" style={{ fontFamily: 'Arial' }} align="left" color="textPrimary" >
                  Weeks or months to integrate
                </Typography>
              </Box>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                style={{padding:5}}
                >
                <ClearIcon  style={{color:"red", marginRight: 5, marginTop: 5}}/>
                <Typography variant="h6" style={{ fontFamily: 'Arial' }} align="left" color="textPrimary" >
                  Lost time and revenue
                </Typography>
              </Box>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                style={{padding:5}}
                >
                <ClearIcon  style={{color:"red", marginRight: 5, marginTop: 5}}/>
                <Typography variant="h6" style={{ fontFamily: 'Arial' }} align="left" color="textPrimary" >
                  Custom scripts for DAG creation
                </Typography>
              </Box>
              <Box style={{padding:20}}></Box>
              </Paper>
              </Grid>

              <Grid item xs={12} sm={12} md={6} lg={6}>
              <Paper elevation={5} >
              <Box style={{padding:20}}></Box>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                style={{padding:20}}
                >
                 <Typography component="h1" variant="h4" style={{ fontStyle: 'bolded', fontFamily: 'Arial' }} align="center" color="textPrimary" gutterBottom>
                  After FloSQL
                </Typography>
              </Box>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                style={{padding:10}}
                >
                  <img className={classes.image} style={{maxWidth:120}} src={Base13Icon}/>
              </Box>
              <Box style={{padding:20}}></Box>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                style={{padding:5}}
                >
                <CheckIcon  style={{color:"green", marginRight: 5, marginTop: 5}}/>
                <Typography variant="h6" style={{ fontFamily: 'Arial' }} align="left" color="textPrimary" >
                  Onboard Data Analysts quickly
                </Typography>
              </Box>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                style={{padding:5}}
                >
                <CheckIcon  style={{color:"green", marginRight: 5, marginTop: 5}}/>
                <Typography variant="h6" style={{ fontFamily: 'Arial' }} align="left" color="textPrimary" >
                  Build data pipelines in minutes
                </Typography>
              </Box>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                style={{padding:5}}
                >
                <CheckIcon  style={{color:"green", marginRight: 5, marginTop: 5}}/>
                <Typography variant="h6" style={{ fontFamily: 'Arial' }} align="left" color="textPrimary" >
                  Leverage your data immediately
                </Typography>
              </Box>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                style={{padding:5}}
                >
                <CheckIcon  style={{color:"green", marginRight: 5, marginTop: 5}}/>
                <Typography variant="h6" style={{ fontFamily: 'Arial' }} align="left" color="textPrimary" >
                  Anyone can build with just SQL
                </Typography>
              </Box>
              <Box style={{padding:20}}></Box>
              </Paper>
              </Grid>
          </Grid>

        </Box>*/}

        <Grid container spacing={5} alignItems="flex-end">

        <Grid item xs={12} sm={12} md={6} lg={6}>
        <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        style={{padding:20}}
        >
        <Card className={classes.cardCaseStudy} elevation={2} >
            <Box style={{padding:10}} >
            <CardContent >
              <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                style={{padding:5}}
                >
                  <img className={classes.smsLiveLogo} src={SMSLiveLogo}/>
              </Box>

              <Typography variant="h5" color="textSecondary" component="p" style={{paddingLeft:20, paddingTop:40, paddingRight:20}}>
                "We reached our data strategy goals with FloSQL in days saving us time and money in development costs."
              </Typography>
              <Typography variant="h5" color="textSecondary" component="p" align="right" style={{paddingRight:50, paddingTop:20}}>
                James Corr
              </Typography>
              <Typography variant="h5" color="textSecondary" component="p" align="right" style={{paddingRight:50, paddingTop:0}}>
                Founder
              </Typography>

            </CardContent>
            </Box>
            <Box display="flex" alignItems="center" justifyContent="center" style={{padding:10}}>
            <CardActions >
              <Button size="large" href='/SMSLiveCaseStudy/' variant="outlined" style={{color: "#0284c7", textTransform: 'none'}} >
                Case Study
              </Button>
            </CardActions>
            </Box>

        </Card>
        </Box>
        </Grid>

        <Grid item xs={12} sm={12} md={6} lg={6}>
        <Box
        display="flex"
        style={{padding:20}}
        >
        <Card className={classes.cardCaseStudy} >
            <Box style={{padding:10}}>
            <CardContent>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                style={{padding:5}}
                >
                  <img className={classes.streamLocatorLogo} src={StreamLocatorLogo}/>
              </Box>
              <Typography variant="h5" color="textSecondary" component="p" style={{paddingLeft:20, paddingTop:40, paddingRight:20}}>
                "FloSQL made it easy for us to combine all of our sources of data so we could build
                insights to drive purchases."
              </Typography>
              <Typography variant="h5" color="textSecondary" component="p" align="right" style={{paddingRight:50, paddingTop:20}}>
                Jason Salzman
              </Typography>
              <Typography variant="h5" color="textSecondary" component="p" align="right" style={{paddingRight:50, paddingTop:0}}>
                COO
              </Typography>
            </CardContent>
            </Box>
            <Box display="flex" alignItems="center" justifyContent="center" style={{padding:10}}>
            <CardActions >
              <Button  fullwidth size="large" href='/StreamLocatorCaseStudy' variant="outlined" style={{color: "#0284c7", textTransform: 'none'}} >
                Case Study
              </Button>
            </CardActions>
            </Box>
        </Card>
        </Box>
        </Grid>
        </Grid>

        {/*<Box style={{padding:50}}></Box>*/}

      </Container>



      <Container maxWidth="sm" component="main" className={classes.heroContent}>
      <Box style={{padding:20}} >
        <Typography component="h1" variant="h2" align="center" color="textPrimary" gutterBottom>
          Pricing
        </Typography>
        <Typography variant="h5" align="center" color="textSecondary" component="p">
          Start building the future of analytics with FloSQL
        </Typography>
      </Box>
      </Container>
      {/* End hero unit */}
      <Container maxWidth="md" component="main">
        <Grid container spacing={5} alignItems="flex-end">
          {tiers.map((tier) => (
            // Enterprise card is full width at sm breakpoint
            <Grid item key={tier.title} xs={12} sm={tier.title === 'Enterprise' ? 12 : 6} md={4}>
              <Card>
                <CardHeader
                  title={tier.title}
                  subheader={tier.subheader}
                  titleTypographyProps={{ align: 'center' }}
                  subheaderTypographyProps={{ align: 'center', color: "white" }}
                  action={tier.title === 'Pro' ? <StarIcon /> : null}
                  className={classes.cardHeader}
                  style={tier.style}
                />
                <CardContent>
                  <div className={classes.cardPricing}>
                    <Typography component="h2" variant="h4" color="textPrimary">
                      {tier.price}
                    </Typography>
                  </div>
                  <div className={classes.cardPricing}>
                    <Typography variant="h6" color="textSecondary">
                      {tier.value}
                    </Typography>
                  </div>
                  <ul>
                    {tier.description.map((line) => (
                      <Typography component="li" variant="subtitle1" align="center" key={line}>
                        {line}
                      </Typography>
                    ))}
                  </ul>
                </CardContent>
                <CardActions>
                  <Button fullWidth href={tier.buttonLink} variant={tier.buttonVariant} style={tier.buttonStyle} color="primary">
                    {tier.buttonText}
                  </Button>
                </CardActions>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
      {/* Footer */}
      <Footer/>
      {/* End footer */}
    </React.Fragment>
  );
}